const MIN_RETRY_MS = 500;
const MAX_RETRY_MS = 5000;

export function planThumbnailRetryDelayMs(retryAfter: string | null, attempt: number): number {
    const headerSeconds = retryAfter === null ? NaN : Number(retryAfter);
    if (Number.isFinite(headerSeconds) && headerSeconds >= 0) {
        return Math.max(MIN_RETRY_MS, Math.min(MAX_RETRY_MS, headerSeconds * 1000));
    }

    return Math.min(MAX_RETRY_MS, 1000 * Math.pow(2, Math.max(0, attempt)));
}

export function isRetryableThumbnailStatus(status: number): boolean {
    return status === 202 || status === 0 || status >= 500;
}
